<template>

  <div class="edit-return pad">
    <h1 class="title is-4">Edit Return Authorisation</h1>
    <div class="has-text-centered" v-if="loading">
      <br /><br />
      LOADING<br /><br />
      <font-awesome-icon size="2x" icon="spinner" pulse />
    </div>
    <b-message type="is-danger" v-if="errMsg">{{ errMsg }}</b-message>
    <div class="box" v-if="ra">
      <return-authorisation-form :ra="ra" :express="true" @submitted="submitted" />
    </div>
  </div>

</template>

<script>
import ReturnAuthorisationForm from '@/components/ReturnAuthorisationForm'
export default {
  name: 'EditReturn',
  components: {
    ReturnAuthorisationForm
  },
  data () {
    return {
      ra: null,
      errMsg: null
    }
  },
  created () {
    this.fetchRa(this.$route.params.id)
  },
  beforeRouteUpdate (to, from) {
    this.fetchRa(to.params.id)
  },
  methods: {
    fetchRa (rid) {
      this.loading = true
      this.errMsg = null
      this.$api('get_return', { rid })
        .then(resp => {
          this.ra = resp.data
          this.loading = false
        })
        .catch(err => {
          this.errMsg = err
          this.loading = false
          console.error(err)
        })
    },
    submitted () {
      this.$snackbar.open({
        message: 'Return authorisation successfully updated!',
        type: 'is-success',
        position: 'is-bottom',
        indefinite: false
      })
      setTimeout(() => this.$router.push('/return-authorisation'), 500)
    }
  }
}
</script>

<style>

</style>
